import { AgCellLocalStoreService, AgCellState } from '../../../../global/gx-ag-grid/ag-cell-local-store.service';
import { Injectable } from '@angular/core';

export interface StoreCodeCellState extends AgCellState {}

@Injectable()
export class StoreCodeCellLocalStoreService extends AgCellLocalStoreService<StoreCodeCellState> {

  constructor() {
    super({
      cellValue: '',
      params: null
    })
  }
}